import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <span className="footer-logo"></span>
            <p className="footer-desc">Empowering your business online</p>
          </div>
          <div className="footer-links">
            <a href="/policy-pages/privacy-policy.html">Privacy Policy</a>
            <a href="/policy-pages/terms-and-conditions.html">Terms & Conditions</a>
            <a href="/policy-pages/cancellation-refund-policy.html">Refund & Cancellation</a>
            <a href="/policy-pages/shipping-delivery-policy.html">Shipping & Delivery</a>
          </div>
          <div className="footer-contact">
            <p> <a href="mailto:contact@webdpro.in">contact@webdpro.in</a></p>
            <p>© 2026 Webdpro Solutions Private Limited. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;